/**
 * AUTO-GENERATED FILE, DO NOT EDIT!
 * =================================
 * This file is automatically generated through the Figma API. If you want to
 * add or update these tokens, let the DS team know through a Jira ticket.
 * Manual additions will be automatically overwritten.
 */

import classNames from 'classnames';

import type { IllustrationProps } from '../types';

export const ThreeDIllustration = ({
  className,
  color = 'sapphire',
  ...otherProps
}: IllustrationProps): JSX.Element => (
  <svg
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-label="ThreeDIllustration"
    role="img"
    viewBox="0 0 112 72"
    xmlns="http://www.w3.org/2000/svg"
    width="112"
    height="72"
    fill="none"
    className={classNames('cogs-illustration', 'cogs-themed-icon', className)}
    {...otherProps}
  >
    <g fill={`var(--cogs-decorative--${color}--400)`} opacity=".5">
      <path d="m55.546 37.895-20.213-10.94a1 1 0 0 1 0-1.758l20.213-10.94a1 1 0 0 1 .952 0l20.213 10.94a1 1 0 0 1 0 1.759l-20.213 10.94a1 1 0 0 1-.952 0M52.066 67.201 31.75 56.207a1 1 0 0 1-.524-.879V31.436a1 1 0 0 1 1.476-.879l20.315 10.994a1 1 0 0 1 .524.88v23.891a1 1 0 0 1-1.476.88M80.29 56.207 59.976 67.201a1 1 0 0 1-1.476-.879V42.431a1 1 0 0 1 .525-.88l20.314-10.994a1 1 0 0 1 1.476.88v23.891a1 1 0 0 1-.525.88" />
    </g>
    <g fill={`var(--cogs-decorative--${color}--400)`} opacity=".3">
      <path d="M25.526 23.85 9.711 14.936a1 1 0 0 1 0-1.742l15.815-8.916a1 1 0 0 1 .983 0l15.815 8.916a1 1 0 0 1 0 1.742L26.509 23.85a1 1 0 0 1-.983 0M22.542 48.16 6.691 39.223a1 1 0 0 1-.509-.87v-19.51a1 1 0 0 1 1.491-.87l15.851 8.936a1 1 0 0 1 .51.87v19.51a1 1 0 0 1-1.492.87M45.343 39.223 29.49 48.16a1 1 0 0 1-1.49-.871v-19.51a1 1 0 0 1 .508-.87l15.852-8.936a1 1 0 0 1 1.49.87v19.51a1 1 0 0 1-.508.87" />
    </g>
    <g fill={`var(--cogs-decorative--${color}--400)`} opacity=".3">
      <path d="m85.526 23.85-15.815-8.915a1 1 0 0 1 0-1.742l15.815-8.916a1 1 0 0 1 .983 0l15.815 8.916a1 1 0 0 1 0 1.742L86.509 23.85a1 1 0 0 1-.983 0M82.542 48.16l-15.851-8.937a1 1 0 0 1-.509-.87v-19.51a1 1 0 0 1 1.491-.87l15.851 8.936a1 1 0 0 1 .51.87v19.51a1 1 0 0 1-1.492.87M105.343 39.223 89.491 48.16a1 1 0 0 1-1.49-.871v-19.51a1 1 0 0 1 .508-.87l15.852-8.936a1 1 0 0 1 1.491.87v19.51a1 1 0 0 1-.509.87" />
    </g>
  </svg>
);
